const seasonalPalette = [
  '#ffa600',
  '#bc5090',
  '#ff423a',
  '#00bbc2',
  '#4079e5',
  '#c10085',
  '#00c600',
  '#ffff01',
];

const piePalette = [
  '#a56900',
  '#79345d',
  '#a52c27',
  '#005f63',
  '#274a8d',
  '#610043',
  '#006100',
  '#929200',
];

const stackedPaletteBlue = [
  '#2E93fA',
  '#45a0ff',
  '#5cacff',
  '#71b7ff',
  '#80bcff',
  '#92c3ff',
  '#a3cdff',
  '#b8d8ff',
];

const stackedPalette = [
  "#003f5c",
  "#2f4b7c",
  "#665191",
  "#a05195",
  "#d45087",
  "#f95d6a",
  "#ff7c43",
  "#ffa600",
];

const trackingPalette = [
  '#4079e5',
  '#ffa600',
  '#bc5090',
  '#ff423a',
  '#00bbc2',
  '#c10085',
  '#00c600',
  '#ffff01',
];

const modelVoyagePalette = [
  '#ff423a',
  '#00bbc2',
  '#4079e5',
  '#ff423a',
  '#00bbc2',
];

export {
  seasonalPalette,
  piePalette,
  stackedPalette,
  stackedPaletteBlue,
  trackingPalette,
  modelVoyagePalette,
}
